<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('financialYear') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'yearList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('yearList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-text-field
              v-model="name"
              :label="$t('name')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="from"
                :label="$t('startDate')"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="from"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="to"
                :label="$t('endDate')"
                :rules="[v => !!v || $t('is-required')]"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="to"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="from"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
        </v-row>
<!--        <v-row>-->
<!--          <v-form-base-->
<!--            :model="model"-->
<!--            :schema="schema"-->
<!--          />-->
<!--        </v-row>-->
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="goTo( 'yearList' )"
            >
              {{ $t('financialYear') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  // import VFormBase from 'vuetify-form-base'
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  export default {
    name: 'Product',
    components: {
      // VFormBase,
      Snakbar,
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      schema: {
        user: 'text', // string shorthand
        password: {
          type: 'password',
          clearable: true,
        },
        checkbox: 'checkbox', // string shorthand
        slider: {
          type: 'slider',
          label: 'Slider',
        },
        color: {
          type: 'color',
          ext: 'text',
          label: 'Color',
        },
        file: {
          type: 'file',
          label: 'Images',
          showSize: true,
          counter: true,
          multiple: true,
        },
      },
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      to: null,
      from: null,
      tag: null,
      content: null,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      type: null,
      id: null,
      status: 'active',
      model: {},
      group: null,
      loading: false,
    }),
    watch: {
      snakbar () {
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
      }
    },
    mounted () {
    },
    methods: {
      log (val) {
      },
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'year', app.$data)
          .then(res => {
            app.goTo('yearList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'year/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.name = res.name
              app.to = res.end_date
              app.from = res.start_date
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'year/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.goTo('yearList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
